
import { Vue, Component } from "vue-property-decorator";
import api from "@/api/index";
import {ProfitReportStandardDto, ProfitType} from "../../api/appService";
const ouKey = "Abp-OrganizationUnitId";
import Cookies from "js-cookie";
import ExportTableHtml from "@/components/ExportTableHtml/index.vue";
import ReportTable from "@/views/report/component/report-table.vue";
import ReportTip from "@/views/report/component/report-tip.vue";
export const getOu = () => Cookies.get(ouKey);
@Component({
  components: {ReportTip, ReportTable, ExportTableHtml}
})
export default class ProjectDetail extends Vue {
  detail: ProfitReportStandardDto[] = [];
  storesList: any[] = [];
  month: Number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  queryForm: any = {
    year: undefined
  };

  get profitType(){
    return ProfitType.Headquarters;
  }

  async created() {
    this.queryForm.year = new Date().getFullYear();
    await this.fetchDetail();
  }

  async fetchDetail() {
    await api.profitReport
      .getProfitOfHeadquarters({
        year: this.queryForm.year
      })
      .then(res => {
        this.detail = res;
      });
  }

  // 搜索
  async handleSearch() {
    await this.fetchDetail();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      year: new Date().getFullYear()
    };
    await this.fetchDetail();
  }

  fetchStores() {
    let that = this;
    api.client.getStores().then(res => {
      this.storesList = res;
    });
  }

  back() {
    this.$router.go(-1);
  }
}
